// activeCompany.js — mutable mirror of the company selected in the switcher.
//
// Why this exists: per-company module permission overrides
// (user_profiles.company_permissions) must apply to hasPermission /
// canAccessModule / getUserPermissions, but CompanyProvider renders BELOW
// AuthProvider (see App.js), so AuthContext cannot call useCompany — and it
// must not re-render on every company switch anyway.
//
// Contract:
// - CompanyContext writes it synchronously during its render (before its
//   children render), so every consumer reads a fresh value.
// - AuthContext reads it at CHECK time (inside the permission helpers), not
//   when the context value is created.
// - null (or the "All Companies" view) → base permissions only: role
//   defaults + the flat `permissions` override, no company scope.
// - NOT React state: reads happen inside plain functions used across the
//   sidebar, route guards and page-level action gates.
let activeCompanyId = null;

export const setActiveCompanyId = (companyId) => {
  activeCompanyId = companyId || null;
};

export const getActiveCompanyId = () => activeCompanyId;
